var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ZoomIn = function (props) {
    var zoom = props.zoom, zoomMax = props.zoomMax, zoomIn = props.zoomIn;
    return (_jsxs("button", __assign({ className: "rt-controls__button rt-controls__button--zoom-in", disabled: !!(zoomMax && zoom >= zoomMax), onClick: zoomIn, type: "button" }, { children: [_jsx("span", __assign({ className: "rt-visually-hidden" }, { children: "Zoom In" })), _jsx("svg", __assign({ viewBox: "1 1 59 59", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsxs("g", __assign({ fillRule: "evenodd" }, { children: [_jsx("path", { d: "M12.5 22h24v6h-24z" }), _jsx("path", { d: "M27.5 13v24h-6V13z" }), _jsx("path", { d: "M25 48.5C12.02 48.5 1.5 37.98 1.5 25S12.02 1.5 25 1.5 48.5 12.02 48.5 25 37.98 48.5 25 48.5zm-.12-6.24c9.6 0 17.38-7.78 17.38-17.38 0-9.6-7.78-17.38-17.38-17.38-9.6 0-17.38 7.78-17.38 17.38 0 9.6 7.78 17.38 17.38 17.38z" }), _jsx("rect", { width: "24", height: "8", rx: "4", transform: "rotate(45 -22.312 67.766)" })] })) }))] })));
};
export default ZoomIn;
